import React from 'react'
import PropTypes from 'prop-types'
import './index.less'
import giphyLogo from '/public/img/giphy-2.png'

export const SelectedGif = ({ gif, showGiphyLogo }) => {
  return (
    <div style={{ margin: '0 auto', float: 'left' }}>
      <img src={gif} id='selected-gif' />
      {showGiphyLogo && gif ? <img align='right' src={giphyLogo} /> : false}
    </div>
  )
}
SelectedGif.propTypes = {
  /** Url of the selected gif */
  gif: PropTypes.string,

  /** Show GIPHY logo */
  showGiphyLogo: PropTypes.bool,
}
